var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfdiv"},[_c('canvas',_vm._b({attrs:{"id":_vm.id_num}},'canvas',_vm.canvasAttrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }